<div class="page-header">
  <div class="grid-container">
  <div class="domain-header" [innerHtml]="domain?.name | domainNameConverter : true"></div>
  <div class="navigation-section">
    <button class="iana-navigation-button" [disabled]="screen === 0" (click)="switchView('ZONE')">Root Zone Data</button>
    <button class="iana-navigation-button" [disabled]="screen === 1" (click)="switchView('AUTH')">Authorizers</button>
  </div>
  </div>
</div>
<div class="grid-container">
<finalize-request-view *ngIf="domainModified" (decision)="finalizeRequest($event)"></finalize-request-view>
<div class="grid-y" *ngIf="screen === 0">
  <div class="header-helper">This page details the root zone delegation record for this domain. Click "Modify" for the
    section you want to modify and update the information. Before final submission, you will be asked to review and
    confirm your changes.
  </div>
  <lib-open-change-requests *ngIf="openCangeRequestsWithSummaries.length >0" [openChangeRequests]="openCangeRequestsWithSummaries"></lib-open-change-requests>
  <div *ngIf="!isRoot()">
    <div *ngIf="(requestMetadata && requestMetadata.requestType === 'DIRECT') || viewMode">
          <meta-data [viewMode]="viewMode"
                     [lastchange]="domain?.metadata | valueFromMap : serverConstants.LAST_UPDATE_FIELD_NAME: serverConstants.META_DATA_FIELD_NAME"
                     [domain]="domain"
                     (modifiedTLDOutput)="modifiedDomain($event)" [change]="metaDataChange"></meta-data>
    </div>
    <sponsoring-org [viewMode]="viewMode"
                    [lastchange]="domain?.metadata | valueFromMap : serverConstants.LAST_UPDATE_FIELD_NAME: serverConstants.SPONSORING_FIELD_NAME"
                    [domain]="domain"
                    [pendingRequestChangeID]="domain | pendingRequestIdExtractor: editChangeRequestMode : requestMetadata.ticketNumber:  serverConstants.SPONSORING_FIELD_NAME"
                    (modifiedTLDOutput)="modifiedDomain($event)" [change]="organizationChange"></sponsoring-org>
    <div class="content-header">Public Points of Contact</div>
    <div class="header-helper">The administrative and technical contacts are published as points of contact for the top-level domain in public databases like RDAP and the IANA
      website. These contacts should be responsive to customer service enquiries from the general public for this domain. They are not used for authorizing change requests for this
      domain
    </div>

    <div class="grid-x">
      <div [ngClass]="getSize('AC')">
        <contact-info [type]="'AC'" [viewMode]="viewMode" (contactInfoEditModeEnabled)="acEditModeEnabled($event)"
                      [lastchange]="domain?.metadata | valueFromMap : serverConstants.LAST_UPDATE_FIELD_NAME: serverConstants.ADMINISTRATIVE_FIELD_NAME"
                      [domain]="domain"
                      [pendingRequestChangeID]="domain | pendingRequestIdExtractor: editChangeRequestMode : requestMetadata.ticketNumber:  serverConstants.ADMINISTRATIVE_FIELD_NAME"
                      [contactVO]="domain?.administrative"
                      (modifiedTLDOutput)="modifiedDomain($event)" [change]="adminContactChange"></contact-info>
      </div>

      <div [ngClass]="getSize('TC')">
        <contact-info [type]="'TC'" [viewMode]="viewMode" (contactInfoEditModeEnabled)="tcEditModeEnabled($event)"
                      [lastchange]="domain?.metadata | valueFromMap : serverConstants.LAST_UPDATE_FIELD_NAME: serverConstants.TECHNICAL_FIELD_NAME"
                      [domain]="domain" [contactVO]="domain?.technical"
                      [pendingRequestChangeID]="domain | pendingRequestIdExtractor: editChangeRequestMode : requestMetadata.ticketNumber:  serverConstants.TECHNICAL_FIELD_NAME"
                      (modifiedTLDOutput)="modifiedDomain($event)"
                      [change]="techContactChange"></contact-info>
      </div>
    </div>
  </div>


  <name-servers [viewMode]="viewMode" [domain]="domain" [nsChange]="nsChange"
                [pendingRequestChangeID]="domain | pendingRequestIdExtractor: editChangeRequestMode : requestMetadata.ticketNumber:  serverConstants.NAME_SERVERS_FIELD_NAME"
                (modifiedTLDOutput)="modifiedDomain($event)"></name-servers>
  <div *ngIf="!isRoot()">

    <trust-anchors [viewMode]="viewMode" [domain]="domain" (modifiedTLDOutput)="modifiedDomain($event)"
                   [pendingRequestChangeID]="domain | pendingRequestIdExtractor: editChangeRequestMode : requestMetadata.ticketNumber:  serverConstants.TRUST_ANCHORS_FIELD_NAME"
                   [trustAnchorsChange]="trustAnchorsChange"></trust-anchors>


    <sub-domain-info [viewMode]="viewMode" [domain]="domain" (modifiedTLDOutput)="modifiedDomain($event)"
                     [registryURLChange]="registryURLChange" [whoIsChange]="whoIsChange"
                     [hideEdit]="editChangeRequestMode"
                     [rdapServerChange]="rdapServerChange"></sub-domain-info>

  </div>

  <div *ngIf="(requestMetadata && requestMetadata.requestType === 'DIRECT') || viewMode">
    <lib-audit-log [auditLog]="domain.auditLog" [domainName]="domain.name"></lib-audit-log>
  </div>
</div>
<lib-auth-policy *ngIf="screen === 1" [domain]="domain" [viewMode]="viewMode"
                 [lastchange]="domain?.metadata | valueFromMap : serverConstants.LAST_UPDATE_FIELD_NAME: serverConstants.AUTH_POLICY_FIELD_NAME"
                 [pendingRequestChangeID]="domain | pendingRequestIdExtractor: editChangeRequestMode : requestMetadata.ticketNumber:  serverConstants.AUTH_POLICY_FIELD_NAME"
                 (modifiedTLDOutput)="modifiedDomain($event)" [authPolicyChange]="authPolicyChange" [authPolicyUsersChange]="authPolicyUsersChange"></lib-auth-policy>
<finalize-request-view *ngIf="domainModified" (decision)="finalizeRequest($event)"></finalize-request-view>
</div>